import { useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { web, errMsg } from "../../lib/api";
import { Btn } from "./kit";
import { Modal, Field, TextArea } from "./Form";

const DAY = 864e5;
/** Reminders can go out for events from 2 hours ago up to 3 days ahead. */
export const canRemind = (start) => {
  const t = new Date(start).getTime();
  return !Number.isNaN(t) && t >= Date.now() - 2 * 36e5 && t <= Date.now() + 3 * DAY;
};

const when = (iso) => new Date(iso).toLocaleString(undefined, { weekday: "short", hour: "numeric", minute: "2-digit" });

export const RemindTeam = ({ e, tid, levelName, last, title, onSent }) => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (ev) => {
    ev.preventDefault();
    setBusy(true);
    try {
      const { data } = await web.post(`/teams/${tid}/schedule/${e.id}/remind`, { note: note.trim() || null });
      toast.success(`Reminder sent to ${data?.sent ?? 0} ${levelName} player${data?.sent === 1 ? "" : "s"} and parent${data?.sent === 1 ? "" : "s"}${data?.failed ? `, ${data.failed} failed` : ""}`);
      setOpen(false);
      setNote("");
      onSent();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Btn variant="ghost" data-testid={`event-remind-${e.id}`} onClick={() => setOpen(true)} className="px-4 py-2 text-xs"><BellRing className="h-3.5 w-3.5" />Remind team</Btn>
      {last?.sent_at && <span data-testid={`event-reminded-${e.id}`} className="self-center font-mono-gd text-[11px] uppercase tracking-wider text-slate-400">Reminded {when(last.sent_at)}</span>}
      <Modal open={open} onClose={() => setOpen(false)} testid="remind-dialog" title="Remind the team" description={`Emails every ${levelName} player and parent who has joined the team about "${title}".`}>
        <form onSubmit={send} className="mt-2 space-y-4">
          <Field label="Add a message (optional)"><TextArea data-testid="remind-note-input" value={note} maxLength={500} onChange={(x) => setNote(x.target.value)} placeholder="Bring both jerseys. Bus leaves at 4:30." /></Field>
          <div className="flex justify-end gap-2">
            <Btn type="button" variant="ghost" data-testid="remind-cancel" onClick={() => setOpen(false)}>Cancel</Btn>
            <Btn type="submit" disabled={busy} data-testid="remind-send"><BellRing className="h-4 w-4" />{busy ? "Sending…" : "Send reminder"}</Btn>
          </div>
        </form>
      </Modal>
    </>
  );
};
